import FooterContainer from "./FooterContainer";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";

const NotFoundContainer = () => {
    const navigate = useNavigate();

    return (
        <>
            <div style={{textAlign: 'center'}}>
                <h1>Página no encontrada</h1>
            
                <Button as="button" primario={"primario"} onClick={() => navigate('/')}>
                    {'Volver a inicio'}  
                </Button> 
            </div>           
            <FooterContainer />
        </>
    );
}

export default NotFoundContainer;